import React from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Header from 'wanderu-component-header';
import { selectors as browserMeta } from 'wanderu-ducks-browser-meta';
import {
    partnerSelectors,
} from 'wanderu-ducks-partner-data';
import {
    selectCurrency,
    selectLocale,
    languageSelector,
    i18nCoordinator,
} from 'wanderu-i18n';

function HeaderContainer(props) {
    const {
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        dispatch,
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        history,
        // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
        match,
        location,
        ...otherProps
    } = props;

    return (
        <Header
            {...otherProps}
            native={false}
            onCurrencyChange={i18nCoordinator.updateCurrency}
            onLocaleChange={i18nCoordinator.updateLocale}
            path={location.pathname}
        />
    );
}

HeaderContainer.propTypes = {
    affiliateId: PropTypes.string,
    currency: PropTypes.string,
    dispatch: PropTypes.func,
    globalBannerVisible: PropTypes.bool,
    history: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    language: PropTypes.string,
    locale: PropTypes.string,
    location: PropTypes.object,
    match: PropTypes.object,
    onLogOut: PropTypes.func,
    onMenuToggle: PropTypes.func,
    supportedCurrencies: PropTypes.arrayOf(PropTypes.string),
    supportedLocales: PropTypes.arrayOf(PropTypes.string),
    trackingId: PropTypes.string,
    userFirstName: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
    const partnerDetails = partnerSelectors.selectPartnerDetails(state);
    const ipLocation = browserMeta.selectUserLocation(state);

    return {
        affiliateId: partnerDetails.affiliateId,
        currency: selectCurrency(state),
        ipLocation,
        language: languageSelector(state),
        locale: ownProps.locale || selectLocale(state),
        supportedCurrencies: state.i18n.supportedCurrencies,
        supportedLocales: state.i18n.supportedLocales,
        trackingId: partnerDetails.trackingId,
    };
};

export {
    HeaderContainer,
    mapStateToProps,
};

const ConnectedHeader = connect(mapStateToProps)(HeaderContainer);
export default withRouter(ConnectedHeader);
